<template>
    <div class="userAgreement">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                    <el-input size clearable v-model="searchForm.real_name" placeholder="请输入代理真实姓名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="searchForm.phone" placeholder="请输入代理账号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="handleSearch(searchForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table :data="userTable" size="mini" border style="width: 100%" v-loading="loading">
                <!-- 用户ID -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <!-- 用户账号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="phone"
                    label="代理账号"
                    min-width="100"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.phone" placement="top">
                      <p>{{ scope.row.phone | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 真实姓名 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="real_name"
                    label="真实姓名"
                    min-width="150"
                ></el-table-column>
                <!-- 昵称 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="nickname"
                    label="昵称"
                    min-width="150"
                ></el-table-column>
                <!-- 层级-字段名待修改 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="agreement"
                    label="状态"
                    min-width="100"
                    v-if="level == 0"
                >
                    <template slot-scope="scope">
                        <p  v-if="scope.row.is_agreement==''" style="color:green" v-html="scope.row.agreement"></p>
                        <p  v-if="scope.row.is_agreement!==''" style="color:red" v-html="scope.row.agreement"></p>
                    </template>
                </el-table-column>
                <!-- 实名认证 -->
                <!-- <el-table-column
                    header-align="center"
                    align="center"
                    prop="auth_status"
                    label="实名认证"
                    min-width="60"
                    :formatter="authStatus"
                ></el-table-column> -->
                <!-- 注册时间 -->
                <!-- <el-table-column
                    header-align="center"
                    align="center"
                    prop="create_time"
                    label="注册时间"
                    min-width="150"
                ></el-table-column> -->
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.is_agreement==''" ref="copy" type="text" size="small" :data-clipboard-text="'http://msite.ag.tftpay.com/pages/agreement.html'+'?='+scope.row.salt" @click="copy" id="copy_text">复制协议链接</el-button>
                        &nbsp;
                        <el-link target="_blank" :href="scope.row.url" :underline="false" v-if="scope.row.is_agreement!==''"><el-button size="small" type="text">协议下载</el-button></el-link>
                    </template>
                </el-table-column>
            </el-table> 
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
    </div>
</template>

<script>
import Clipboard from 'clipboard';
export default {
    name: "UM_userAgreement",
    data() {
        return {
            searchForm: {
                page: 1,
                limit: 10,
                agent_name: '', //一级代理姓名
                agent_phone: '',    //一级代理账号
                real_name: '',   //用户真实姓名
                phone: '',   //用户账号
                auth_status: '', //实名认证状态
                parent_real_name: '', // 推荐人真实姓名
                parent_real_phone: '', //推荐人手机号
                level: '', //层级字段
                code:'', //邀请码
                team_classification: '', //所属分类
                create_start_time: '', //用户注册开始时间
                create_end_time: '' //用户注册结束时间
            },
            userTable: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: false,
            level: null,
            // baurl=msite.ag.tftpay.com/pages/agreement.html,
        }
    },
    mounted() {
        this.level = sessionStorage.getItem('level')
        this.getData({
            page: 1,
            limit: 10
        });
    },
    components: {
       
    },
    methods: {
        handleSearch(searchForm) { //搜索
            this.currentPage = 1;
            searchForm.page = 1;
            this.getData(searchForm);
        },
        copy: function () {
            var _this = this;
            var clipboard = new Clipboard('#copy_text');

            clipboard.on('success', e => {
                this.$message({
                        type: 'success',
                        message: "复制成功",
                        duration: 2000,
                    })
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
            // 不支持复制
                Message({
                    message: '该浏览器不支持自动复制',
                    type: 'warning'
                });
                // 释放内存
                clipboard.destroy()
            })
        },
        //分页
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData(this.searchForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData(this.searchForm);
        },
        getData(params) { //初始化数据
            this.loading = true;
            this.$api.post("user/list", params, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.total = data.count; //总数
                    this.userTable = data.list;
                } else {
                    this.$message.error(res.msg);
                }
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        authStatus(row) { //表格内容转换
            let auth_status;
            switch (row.auth_status) {
                case 1:
                    auth_status = "已实名";
                    break;
                case 0:
                    auth_status = "未实名";
                    break;
            }
            return auth_status;
        },
        agentClose(ref) { //关闭添加代理弹窗
            this.agentIsShow = false;
            if (ref) {
                this.getData({
                    page: this.currentPage,
                    limit: this.pageSize,
                });
            }
        },
        blockedClose(ref) { //关闭冻结用户弹窗
            this.blockedIsShow = false;
            if (ref) {
                this.getData({
                    page: this.currentPage,
                    limit: this.pageSize,
                });
            }
        },
    }
};
</script>
